<template>
  <div class="form form-card">
    <div class="form-card__container form-card__container--sm">
      <el-form
        ref="LoginForm"
        class="login-form"
        :model="LoginForm"
        :rules="LoginRules"
        @submit.prevent.native="Login()"
      >
        <!-- 帳號 -->
        <el-form-item prop="loginId" class="form-field">
          <label class="form-label">{{ $t('login.account') }}</label>
          <el-input
            v-model="LoginForm.loginId"
            :placeholder="$t('login.placeholder.account')"
            type="text"
            size="large"
            prefix-icon="el-icon-user"
          />
        </el-form-item>

        <!-- 密碼 -->
        <el-form-item prop="password" class="form-field">
          <label class="form-label">{{ $t('login.password') }}</label>
          <el-input
            v-model="LoginForm.password"
            :placeholder="$t('login.placeholder.password')"
            type="password"
            size="large"
            prefix-icon="el-icon-lock"
            show-password
          />
        </el-form-item>

        <!-- 圖形驗證碼 -->
        <div class="form-group form-group--inline">
          <el-form-item prop="captchaCode" class="form-field form-field--flex">
            <label class="form-label">{{ $t('common.label.captcha') }}</label>
            <el-input
              v-model="LoginForm.captchaCode"
              :placeholder="$t('login.placeholder.captchaCode')"
              type="text"
              size="large"
              prefix-icon="el-icon-picture"
            />
          </el-form-item>
          <div class="captcha-image" @click="GetCaptchaCode">
            <img :src="`data:image/png;base64,${CodeImg}`" alt="驗證碼" />
          </div>
        </div>

        <!-- 記住我 -->
        <div class="form-field form-field--checkbox">
          <el-radio
            v-model="keepMemberAccount"
            :label="true"
            class="form-radio"
          >
            {{ $t('login.rememberMe') }}
          </el-radio>
        </div>

        <!-- 登入按鈕 -->
        <button class="btn-submit full" type="submit">
          {{ $t('login.loginButton') }}
        </button>

        <!-- Line登入 (隱藏) -->
        <!-- <template v-if="false">
          <div class="form-divider">
            <span class="form-divider__text">{{ $t('login.or') }}</span>
          </div>

          <button class="btn-line" type="button" @click="loginFromLine">
            {{ $t('login.lineLogin') }}
          </button>
        </template> -->

        <!-- 頁腳連結 -->
        <div class="form-footer">
          <router-link to="/member/register" class="form-link">
            {{ $t('login.links.register') }}
          </router-link>
          <router-link to="/forgotAccount" class="form-link">
            {{ $t('login.links.forgotAccount') }}
          </router-link>
          <router-link to="/forgot" class="form-link">
            {{ $t('login.links.forgotPassword') }}
          </router-link>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { Login, LineLogin } from '@/api/LoginApi';
import { GetCaptchaCode, GetCaptchaBase64 } from '@/api/CaptchaApi';

export default {
  data() {
    return {
      CodeImg: '',
      keepMemberAccount: false,
      LoginForm: {
        loginId: '',
        password: '',
        sourceTypeId: 1,
        code: '',
        captchaCode: '',
      },
      LoginRules: {
        loginId: [{ required: true, message: this.$t('common.message.accountRequired'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('common.message.passwordRequired'), trigger: 'blur' }],
        captchaCode: [{ required: true, message: this.$t('common.message.captchaRequired'), trigger: 'blur' }],
      },
    };
  },
  created() {
    const myStorage = window.localStorage;
    // eslint-disable-next-line operator-linebreak
    this.LoginForm.loginId =
      myStorage.getItem('MemberAccount') !== null ? myStorage.getItem('MemberAccount') : '';
    this.keepMemberAccount = this.LoginForm.loginId !== '';

    this.GetCaptchaCode();
  },
  methods: {
    GetCaptchaCode() {
      // 取得驗證碼
      GetCaptchaCode().then((response) => {
        if (response.data.statusCode === 0) {
          this.LoginForm.code = response.data.data.code;
          GetCaptchaBase64(this.LoginForm.code).then((res) => {
            this.CodeImg = res.data;
          });
        }
      });
    },
    Login() {
      this.$refs.LoginForm.validate((valid) => {
        if (valid) {
          Login(this.LoginForm).then((response) => {
            if (response.data.statusCode === 0) {
              const myStorage = window.localStorage;
              if (this.keepMemberAccount) {
                myStorage.setItem('MemberAccount', this.LoginForm.loginId);
              } else {
                myStorage.setItem('MemberAccount', '');
              }

              const { jwtToken } = response.data.data;
              // Line先不上線
              // const { ExpTime, IsBinding } = JSON.parse(
              const { ExpTime } = JSON.parse(
                decodeURIComponent(
                  escape(
                    window.atob(
                      jwtToken
                        .split('.')[1]
                        .replace(/-/g, '+')
                        .replace(/_/g, '/'),
                    ),
                  ),
                ),
              );
              const d = this.$moment(ExpTime).add(30, 'days');
              const startDate = this.$moment();
              const endDate = this.$moment(d);
              const seconds = endDate.diff(startDate, 'seconds');
              document.cookie = `token=${jwtToken}; expires=${d}; max-age=${seconds}; path=/`;
              const translatedKey = `API.${response.data.statusCode}`;
              const translated = this.$t(translatedKey, { errorCode: response.data.statusCode });

              this.$message({
                showClose: true,
                type: 'success',
                message: translated !== response.data.statusCode ? translated : response.data.message,
              });
              this.$setUserAccount();
              this.$bus.$emit('getShoppingCartCount');
              const { redirect } = this.$route.query;
              if (redirect) this.$router.replace(redirect);
              else this.$router.replace('/');
              // Line先不上線
              // if (!IsBinding) {
              //   this.$router.push('/member/info');
              // } else {
              //   const { redirect } = this.$route.query;
              //   if (redirect) this.$router.replace(redirect);
              //   else this.$router.replace('/');
              // }
            } else {
              this.GetCaptchaCode();
            }
          });
        } else {
          this.$message({
            showClose: true,
            type: 'error',
            message: this.$t('common.message.required'),
          });
        }
      });
    },
    loginFromLine() {
      LineLogin({
        socialNetwork: 1, // 1:LINE
        sourceTypeId: 1, // 1:前台 9:後台
      }).then((response) => {
        if (response.data.statusCode === 0) {
          // eslint-disable-next-line no-restricted-globals
          location.href = response.data.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
